import cx from 'classnames'
import React, { Fragment } from 'react'

import cream from '@/assets/images/teaser/concept/cream.png'
import essence from '@/assets/images/teaser/concept/essence.png'
import FadeSlider from '@/components/Common/FadeSlider'
import Picture from '@/components/Image/Picture'
import '@/components/Page/Teaser/Introduction/BackgroundImageView/BackgroundImageView.scss'

export default function BackgroundImageView({
  processChangeAnimation = false,
  rootMargin,
  speed,
}: {
  processChangeAnimation?: boolean
  rootMargin: string
  speed: number
}) {
  return (
    <div className={'zoom-out-animate'}>
      <FadeSlider
        speed={speed}
        recoilState={true}
        rootMargin={rootMargin}
        onActiveIndexChange={
          processChangeAnimation
            ? (swiper) => {
                setTimeout(() => {
                  if (swiper === null || swiper === undefined || swiper.destroyed) return
                  const slide = swiper.slides[Math.abs(swiper.activeIndex - 1)]
                  slide.classList.remove('swiper-slide-next')
                  slide.classList.remove('swiper-slide-prev')
                }, speed + 500)
              }
            : () => {}
        }
        items={[
          <Fragment key={1}>
            <Picture
              src={essence.src}
              width={essence.width}
              height={essence.height}
              className={cx('c-backgroundImageView')}
              alt={'FAS THE BLACK ESSENCE'}
            />
          </Fragment>,
          <Fragment key={2}>
            <Picture
              src={cream.src}
              width={cream.width}
              height={cream.height}
              className={cx('c-backgroundImageView')}
              alt={'FAS THE BLACK CREAM'}
            />
          </Fragment>,
        ]}
      />
    </div>
  )
}
